import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Terms() {
    const { t } = useLang('bladeroboticlawnmower.detail.terms');

    return (
        <div className={styles.terms}>
            <div className="bottom-mark">
                <div className="bottom-mark__title">{t('title')}</div>
                <div className="bottom-mark__desc">{t('desc')}</div>

                <div className="bottom-mark__text">{t('text')}</div>
            </div>
        </div>
    );
}
